import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import classNames from 'classnames';
import Button from '../button/Button';
import useMergeRefs from '../../hooks/useMergeRefs';
const DropdownToggleButton = forwardRef((props, ref) => {
    const { id, disabled, bsSize, bsStyle, variant, splitButton = false, onClick, className = '', children, outerRef } = props, remainingProps = __rest(props, ["id", "disabled", "bsSize", "bsStyle", "variant", "splitButton", "onClick", "className", "children", "outerRef"]);
    const toggleRef = useMergeRefs(outerRef, ref);
    const labelButtonClasses = classNames(!splitButton && 'dropdown-toggle', !splitButton && className);
    return (_jsx(Button, Object.assign({}, remainingProps, { id: splitButton ? `button-${id}` : id, type: 'button', ref: toggleRef, disabled: disabled, bsStyle: bsStyle, bsSize: bsSize, variant: variant, onClick: onClick, className: labelButtonClasses }, { children: children })));
});
export default DropdownToggleButton;
